import React from 'react';
import './styles.scss';
import { Table } from '@mantine/core';
import {
  HiOutlineSortAscending,
  HiOutlineSortDescending
} from 'react-icons/hi';
import * as Unicons from '@iconscout/react-unicons';
import { DataTableHeadProps } from '.';

const THead: React.FC<DataTableHeadProps> = ({
  columns,
  data,
  isNumbering,
  meta,
  sortConfig,
  onSort,
  theme
}) => {
  return (
    <Table.Thead>
      <Table.Tr>
        {isNumbering && <Table.Th c={theme?.colors?.text}>No.</Table.Th>}
        {columns.map((column, index) => (
          <Table.Th key={index} c={theme?.colors?.text}>
            {column.sortable && (
              <div
                className="sortable-column"
                style={{ width: column.width }}
                onClick={() => (data.length ? onSort(column) : null)}
              >
                {(!sortConfig.key ||
                  sortConfig.key !==
                    (typeof column.props === 'function'
                      ? column.id
                      : column.props)) && <Unicons.UilSort size={16} />}
                {sortConfig.key ===
                  (typeof column.props === 'function'
                    ? column.id
                    : column.props) &&
                  sortConfig.direction === 'asc' && (
                    <HiOutlineSortAscending size={16} />
                  )}
                {sortConfig.key ===
                  (typeof column.props === 'function'
                    ? column.id
                    : column.props) &&
                  sortConfig.direction === 'desc' && (
                    <HiOutlineSortDescending size={16} />
                  )}
                <div style={{ color: theme?.colors?.text }}>
                  {column.heading}
                </div>
              </div>
            )}
            {!column.sortable && column.heading}
          </Table.Th>
        ))}
      </Table.Tr>
    </Table.Thead>
  );
};

export default THead;
